import React, { useEffect, useState, useRef } from 'react';
import '../App.css'; // Optional: for custom styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import EditText from './EditText';

const DropdownSearch = ({options,returnSelectedOption,returnSearch, keys = [],returnSelectedKey,placeholder,}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!isOpen) {
        setFilteredOptions(options); // Reset options when opening
        setSearchTerm(""); // Clear search box
    }
    setIsOpen(!isOpen);
    };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown
        setSearchTerm(""); // Optional: Clear search when clicking outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    if (typeof returnSearch === "function") {
        returnSearch(value)
    }
    
    setFilteredOptions(
      options.filter((item) =>
        item.toLowerCase().includes(value)
      )
    );
  };

const handleOptionClick = (option) => {
  const index = options.findIndex(opt => opt === option); // Use full options array
  setSelectedOption(option);

  if (typeof returnSelectedOption === "function") {
    returnSelectedOption(option);
  }

  if (typeof returnSelectedKey === "function" && index !== -1) {
    returnSelectedKey(keys[index]);
  }

  setSearchTerm("");
  setIsOpen(false);
};


  // Reset filtered options when base options change
    useEffect(() => {
        if(!searchTerm){
            setSearchTerm("");
        }
        setFilteredOptions(options);
         // clear search term when options change

        // Reset selected option if it's no longer valid or on options reset
        if (!options.includes(selectedOption)) {
            setSelectedOption(null); // reset selected option to show placeholder
        }
        
    }, [options]);

  // Set default selection
  useEffect(() => {
    if (selectedOption && !options.includes(selectedOption)) {
      setSelectedOption(null);
      return;
    }

    if (!selectedOption && !placeholder && options.length > 0) {
      setSelectedOption(options[0]);

      if (typeof returnSelectedOption === "function") {
        returnSelectedOption(options[0]);
      }

      if (typeof returnSelectedKey === "function" && keys.length > 0) {
        returnSelectedKey(keys[0]);
      }
    }
  }, [options, placeholder]);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {isOpen ? (
          <>
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              className="dropdown-search"
              onClick={(e) => e.stopPropagation()}
              onChange={handleSearch}
            />
            
          </>
        ) : (
          <>
            {selectedOption || placeholder || "Selecciona"}
            <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: "5px" }} />
          </>
        )}
      </div>

      {isOpen && (
        <ul className="dropdown-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li key={index} onClick={() => handleOptionClick(option)}>
                {option}
              </li>
            ))
          ) : (
            <li className="dropdown-no-results">No hay resultados</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default DropdownSearch;
